module.exports = __webpack_public_path__ + "img/7-half-lg.9efb8a19.jpg";